import Image from 'global/Image';
import { Common } from '@stockbit/ui';
import { PopoverUser } from 'global/StreamWidget/Popover';
import { AVATAR_URL } from 'constants/api';
import { handleErrorAvatar } from 'utils/general';
import Link from 'next/link';

const { Avatar } = Common;

interface UserAvatarProps {
  username: string;
  avatar: string;
  avatarSize: string;
  showPopover: boolean;
}

function UserAvatar({ username, avatar, avatarSize, showPopover }: UserAvatarProps) {
  const avatarUrl = avatar.startsWith('http') ? avatar : `${AVATAR_URL}/${avatar}`;

  if (showPopover) {
    return (
      <PopoverUser username={username}>
        <span>
          <Link href={`/${username}`}>
            <a style={{ color: 'unset' }}>
              <Avatar size={avatarSize} padding="0">
                <Image
                  alt="imageProfile"
                  src={avatarUrl}
                  onError={(e) => handleErrorAvatar(e, username)}
                  style={{ cursor: 'pointer' }}
                />
              </Avatar>
            </a>
          </Link>
        </span>
      </PopoverUser>
    );
  }

  return (
    <Avatar size={avatarSize} padding="0">
      <Image
        alt="imageProfile"
        src={avatarUrl}
        onError={(e) => handleErrorAvatar(e, username)}
      />
    </Avatar>
  );
}

export default UserAvatar;
